<template>
  <div class="about-page">
    <!-- 整屏模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <!-- 模块一/三背景图（不参与渐入） -->
        <img v-if="item.key === 'hero'" class="mod1-bg" src="@/assets/images/about/about-1-company.png" alt="">
        <img v-if="item.key === 'feature'" class="mod3-bg" src="@/assets/images/about/about-3-back.png" alt="">
        <div class="section-inner">

          <!-- 模块一：公司首屏 -->
          <div v-if="item.key === 'hero'" class="mod1-layout">
            <div class="mod1-content">
              <h1 class="mod1-title">{{ $t('about.heroTitle') }}</h1>
              <p class="mod1-subtitle">{{ $t('about.heroSubtitle') }}</p>
              <!-- 招聘仅中文版 -->
              <button v-if="$i18n.locale !== 'en'" class="mod1-btn" @click="$router.push('/join')">{{ $t('about.heroBtn') }} &gt;</button>
            </div>
          </div>

          <!-- 模块二：公司简介 -->
          <div v-if="item.key === 'intro'" class="mod2-layout">
            <div class="mod2-header">
              <h2 class="mod2-title">{{ $t('about.introTitle') }}</h2>
              <p class="mod2-subtitle">{{ $t('about.introSubtitle') }}</p>
            </div>
            <div class="mod2-divider"></div>
            <!-- 公司介绍 -->
            <p class="mod2-desc">{{ $t('about.companyDesc') }}</p>
            <div class="mod2-icons">
              <div class="mod2-icon-item">
                <img class="mod2-icon" src="@/assets/images/about/about-2-1.png" alt="">
                <span class="mod2-icon-label">{{ $t('about.iconLabel1') }}</span>
              </div>
              <div class="mod2-icon-item">
                <img class="mod2-icon" src="@/assets/images/about/about-2-2.png" alt="">
                <span class="mod2-icon-label">{{ $t('about.iconLabel2') }}</span>
              </div>
              <div class="mod2-icon-item">
                <img class="mod2-icon" src="@/assets/images/about/about-2-3.png" alt="">
                <span class="mod2-icon-label">{{ $t('about.iconLabel3') }}</span>
              </div>
            </div>
            <!-- 公司图片（手机端用竖版） -->
            <img class="mod2-img" :src="isMobile ? require('../assets/images/about/about-2-mobilecompany.png') : require('../assets/images/about/about-2-company.png')" alt="">
          </div>

          <!-- 模块三：发展历程 -->
          <div v-if="item.key === 'feature'" class="mod3-layout">
            <div class="mod3-header">
              <h2 class="mod3-title">{{ $t('about.devTitle') }}</h2>
              <div class="mod3-title-line"></div>
            </div>
            <!-- 2026/2025/2024/2021，上下交错 -->
            <div class="mod3-timeline">
              <div class="tl-line"></div>
              <div class="tl-item">
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear1') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc1') }}</p>
                <div class="tl-stem tl-stem-2026"></div>
                <div class="tl-node tl-node-2026"></div>
                <div class="tl-year-bar tl-year-bar-2026"></div>
              </div>
              <div class="tl-item">
                <div class="tl-node tl-node-2025"></div>
                <div class="tl-stem tl-stem-2025"></div>
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear2') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc2') }}</p>
                <div class="tl-year-bar tl-year-bar-2025"></div>
              </div>
              <div class="tl-item">
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear3') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc3') }}</p>
                <div class="tl-stem tl-stem-2024"></div>
                <div class="tl-node tl-node-2024"></div>
                <div class="tl-year-bar tl-year-bar-2024"></div>
              </div>
              <div class="tl-item">
                <div class="tl-node tl-node-2021"></div>
                <div class="tl-stem tl-stem-2021"></div>
                <div class="tl-year"><span class="tl-year-num">{{ $t('about.devYear4') }}</span><span v-if="$i18n.locale === 'zh'" class="tl-year-char">年</span></div>
                <p class="tl-desc">{{ $t('about.devDesc4') }}</p>
                <div class="tl-year-bar tl-year-bar-2021"></div>
              </div>
            </div>
          </div>

          <!-- 模块四：联系我们 -->
          <div v-if="item.key === 'contact'" class="mod4-layout">
            <div class="mod4-header">
              <h2 class="mod4-title">{{ $t('about.contactTitle') }}</h2>
              <div class="mod4-title-line"></div>
            </div>
            <!-- 桌面端地图：点击跳转高德定位公司（手机端隐藏，英文版切图单独） -->
            <div class="mod4-map" role="button" :aria-label="$t('about.mapTitle')" @click="openAmapPage">
              <img class="mod4-map-img" :src="$i18n.locale === 'en' ? require('../assets/images/about/about-4-INTmap.png') : require('../assets/images/about/about-4-map.png')" alt="公司位置地图">
              <img class="mod4-map-pin" :src="$i18n.locale === 'en' ? require('../assets/images/about/about-4-INTname.png') : require('../assets/images/about/about-4-name.png')" alt="">
            </div>
            <!-- 白卡容器：桌面端包含信息卡与二维码，手机端 display:contents 拆平为列表（不影响手机布局） -->
            <div class="mod4-panel">
              <div class="mod4-left">
                <h3 class="mod4-company">{{ $t('about.companyName') }}</h3>
                <div class="mod4-company-line"></div>
                <!-- 售后（手机端卡片，桌面端 display:contents 拆平） -->
                <div class="mod4-card">
                  <img class="mod4-card-icon" src="@/assets/images/about/about-4-shouhou.png" alt="">
                  <div class="mod4-card-content">
                    <div class="mod4-section">
                      <h4 class="mod4-section-title">{{ $t('about.afterSalesTitle') }}</h4>
                      <p class="mod4-info"><span class="mod4-info-label">{{ $t('about.afterSalesEmail') }}</span><span class="mod4-info-value">{{ $t('about.afterSalesEmailValue') }}</span></p>
                      <p class="mod4-info mod4-info-phone"><span class="mod4-info-label">{{ $t('about.afterSalesPhone') }}</span><span class="mod4-info-value">{{ $t('about.afterSalesPhoneValue') }}</span></p>
                    </div>
                  </div>
                </div>
                <!-- 商务联系 -->
                <div class="mod4-card">
                  <img class="mod4-card-icon" src="@/assets/images/about/about-4-shangwu.png" alt="">
                  <div class="mod4-card-content">
                    <div class="mod4-section">
                      <h4 class="mod4-section-title">{{ $t('about.businessTitle') }}</h4>
                      <p class="mod4-info"><span class="mod4-info-label">{{ $t('about.businessEmail') }}</span><span class="mod4-info-value">{{ $t('about.businessEmailValue') }}</span></p>
                      <p class="mod4-info mod4-info-phone"><span class="mod4-info-label">{{ $t('about.businessPhone') }}</span><span class="mod4-info-value">{{ $t('about.businessPhoneValue') }}</span></p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 公司地址（手机端排第三张卡） -->
              <div class="mod4-address">
                <img class="mod4-card-icon" src="@/assets/images/about/about-4-dizhi.png" alt="">
                <div class="mod4-card-content">
                  <h4 class="mod4-section-title">{{ $t('about.addressTitle') }}</h4>
                  <p class="mod4-address-desc">{{ $t('about.addressDesc') }}</p>
                </div>
                <!-- 打开地图选择 -->
                <span class="mod4-card-arrow" role="button" :aria-label="$t('about.mapTitle')" @click="showMapPicker = true"></span>
              </div>
              <!-- 关注我们（仅手机端） -->
              <div class="mod4-qr-heading">
                <h4 class="mod4-qr-title">{{ $t('about.followTitle') }}</h4>
                <div class="mod4-qr-underline"></div>
              </div>
              <!-- 二维码（英文版单独切图） -->
              <div class="mod4-qr-row">
                <div class="mod4-qr-item">
                  <img class="mod4-img1" :src="$i18n.locale === 'en' ? require('../assets/images/service/service-1-INTguanzhu.png') : require('../assets/images/service/service-1-guanzhu.png')" alt="关注二维码">
                  <div class="mod4-qr-label mod4-qr-label1">
                    <span class="mod4-qr-scan">{{ $t('about.qrScan') }}</span>
                    <span class="mod4-qr-name">{{ $t('about.qrName1') }}</span>
                  </div>
                </div>
                <div class="mod4-qr-item">
                  <img class="mod4-img2" :src="$i18n.locale === 'en' ? require('../assets/images/service/service-1-INTshouhou.png') : require('../assets/images/service/service-1-shouhou.png')" alt="售后二维码">
                  <div class="mod4-qr-label mod4-qr-label2">
                    <span class="mod4-qr-scan">{{ $t('about.qrScan') }}</span>
                    <span class="mod4-qr-name">{{ $t('about.qrName2') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 地图选择弹层（挂到 body，避免被 transform 影响） -->
    <div ref="mapPickerHost" class="map-picker-host">
      <div v-if="showMapPicker" class="map-picker-mask" @click="showMapPicker = false">
        <div class="map-picker" @click.stop>
          <div class="map-picker-title">{{ $t('about.mapTitle') }}</div>
          <div v-for="item in mapLinks" :key="item.label" class="map-picker-item" @click="openMap(item.url)">{{ item.label }}</div>
          <div class="map-picker-cancel" @click="showMapPicker = false">{{ $t('about.mapCancel') }}</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'AboutPage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero' },
        { key: 'intro', className: 'module-intro' },
        { key: 'feature', className: 'module-feature' },
        { key: 'contact', className: 'module-contact' }
      ],
      visibleMap: {},
      observer: null,
      isMobile: false,
      mobileQuery: null,
      // 地图选择弹层
      showMapPicker: false
    }
  },
  computed: {
    // 各大地图导航链接
    mapLinks() {
      const name = encodeURIComponent(this.$t('about.companyName'))
      const addr = encodeURIComponent(this.$t('about.addressDesc'))
      const lat = 22.607275
      const lng = 113.856675
      if (this.$i18n.locale === 'en') {
        return [
          // Google：query 为 纬度,经度
          { label: this.$t('about.mapGoogle'), url: 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng },
          // Apple：官方写法 q=名称@纬度,经度，可在该坐标直接打点
          { label: this.$t('about.mapApple'), url: 'https://maps.apple.com/?q=' + name + '@' + lat + ',' + lng }
        ]
      }
      // 百度需 GCJ-02 转 BD-09
      const bd = this.gcj02ToBd09(lng, lat)
      return [
        // 高德：position 为 经度,纬度
        { label: this.$t('about.mapAmap'), url: 'https://uri.amap.com/marker?position=' + lng + ',' + lat + '&name=' + name + '&src=cofoe&coordinate=gaode&callnative=1' },
        // 腾讯：coord 为 纬度,经度
        { label: this.$t('about.mapTencent'), url: 'https://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' + lng + ';title:' + name + ';addr:' + addr + '&referer=cofoe' },
        // 百度：location 为 纬度,经度（BD-09）
        { label: this.$t('about.mapBaidu'), url: 'https://api.map.baidu.com/marker?location=' + bd[1] + ',' + bd[0] + '&title=' + name + '&content=' + addr + '&output=html&coord_type=bd09ll&src=webapp.cofoe' }
      ]
    }
  },
  mounted() {
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    // 手机端断点
    this.mobileQuery = window.matchMedia('(max-width: 1024px)')
    this.isMobile = this.mobileQuery.matches
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.onMobileChange)
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(this.onMobileChange)
    }
    this.initObserver()
    this.scrollToQueryModule()
    // 弹层挂到 body，避免被 transform 影响
    this.$nextTick(() => {
      const host = this.$refs.mapPickerHost
      if (host) document.body.appendChild(host)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    // 移除挂到 body 的弹层
    const mapHost = this.$refs.mapPickerHost
    if (mapHost && mapHost.parentNode) {
      mapHost.parentNode.removeChild(mapHost)
    }
    if (this.mobileQuery) {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onMobileChange)
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onMobileChange)
      }
    }
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    // GCJ-02 → BD-09
    gcj02ToBd09(lng, lat) {
      const xPi = (Math.PI * 3000) / 180
      const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * xPi)
      const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * xPi)
      return [z * Math.cos(theta) + 0.0065, z * Math.sin(theta) + 0.006]
    },
    // 打开地图
    openMap(url) {
      this.showMapPicker = false
      window.location.href = url
    },
    // 桌面端点击地图：中文站跳高德、英文站跳 Google Maps，均定位到公司经纬度
    openAmapPage() {
      const url = this.$i18n.locale === 'en'
        ? 'https://www.google.com/maps/search/?api=1&query=22.607275,113.856675'
        : 'https://gaode.com/regeo?lng=113.856675&lat=22.607275'
      window.open(url, '_blank', 'noopener')
    },
    onMobileChange(e) {
      this.isMobile = e.matches
    },
    updateScale() {
      // 手机端禁用画布缩放
      if (window.innerWidth <= 1024) {
        this.scale = 1
        return
      }
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    },
    // 页脚 ?to= 参数定位模块
    scrollToQueryModule() {
      const anchor = this.$route.query.to
      if (!anchor) return
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.module-' + anchor)
          if (el) {
            el.scrollIntoView({ behavior: 'auto' })
          }
        }, 100)
      })
    }
  }
}
</script>

<style scoped>
/* 页面公共样式 */

.about-page {
  padding-top: 0;
}

/* 整屏模块 */
.fullscreen-section {
  height: 100vh;
  /* 手机端可见高度 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
}

/* 设计稿画布 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入：仅透明度，隐藏态不设过渡以便重播 */
  opacity: 0;
  will-change: opacity;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transition: opacity 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 模块一 */
.module-hero {
  background: #F5F5F5;
}

.module-hero .mod1-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 背景图 */
.module-hero .mod1-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

.module-hero .mod1-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.module-hero .mod1-title {
  font-size: 80px;
  font-weight: 500;
  color: #FFFFFF;
  letter-spacing: 4px;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 英文版主标题居中 */
:lang(en) .module-hero .mod1-title {
  text-align: center;
}

.module-hero .mod1-subtitle {
  font-size: 38px;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 2px;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

.module-hero .mod1-btn {
  padding: 12px 36px;
  font-size: 20px;
  color: #FFFFFF;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
  border-radius: 30px;
  cursor: pointer;
  letter-spacing: 1px;
  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

.module-hero .mod1-btn:hover {
  background: #FFFFFF;
  color: #333333;
  border-color: #FFFFFF;
}

/* 入场动效 */
.reveal-section .mod1-title,
.reveal-section .mod1-subtitle {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod1-title,
.reveal-section.is-visible .mod1-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 按钮延迟入场 */
.reveal-section .mod1-btn {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod1-btn {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.2s,
    background 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease;
}

/* 模块二 */
.module-intro {
  background: #FFFFFF;
}

.module-intro .mod2-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 公司图片 */
.module-intro .mod2-img {
  position: absolute;
  right: 200px;
  top: 50%;
  transform: translateY(-50%);
  width: 760px;
  height: auto;
}

/* 标题区 */
.module-intro .mod2-header {
  position: absolute;
  left: 276px;
  top: 220px;
}

.module-intro .mod2-title {
  font-size: 50px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 8px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

.module-intro .mod2-subtitle {
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

.module-intro .mod2-divider {
  position: absolute;
  left: 276px;
  top: 370px;
  width: 390px;
  height: 1px;
  background: #D9D9D9;
}

/* 公司介绍 */
.module-intro .mod2-desc {
  position: absolute;
  left: 276px;
  top: 400px;
  width: 600px;
  font-size: 20px;
  font-weight: 400;
  color: #868686;
  line-height: 1.8;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  text-align: justify;
}

/* 英文版公司介绍 */
:lang(en) .module-intro .mod2-desc {
  text-align: justify;
  top: 385px;
}

/* 图标行 */
.module-intro .mod2-icons {
  position: absolute;
  left: 260px;
  top: 720px;
  display: flex;
  align-items: center;
  gap: 200px;
}

.module-intro .mod2-icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.module-intro .mod2-icon {
  width: 70px;
  height: auto;
}

.module-intro .mod2-icon-label {
  font-size: 20px;
  font-weight: 500;
  color: #252525;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 入场动效 */

/* 标题区 */
.reveal-section .mod2-title,
.reveal-section .mod2-subtitle,
.reveal-section .mod2-divider {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod2-title,
.reveal-section.is-visible .mod2-subtitle,
.reveal-section.is-visible .mod2-divider {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.1s,
    transform 1.1s ease 0.1s;
}

/* 公司介绍 */
.reveal-section .mod2-desc {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod2-desc {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 公司图片（保留 translateY 居中） */
.reveal-section .mod2-img {
  opacity: 0;
  transform: translate(48px, -50%);
}

.reveal-section.is-visible .mod2-img {
  opacity: 1;
  transform: translate(0, -50%);
  transition: opacity 1.1s ease 0.3s,
    transform 1.1s ease 0.3s;
}

/* 图标行 */
.reveal-section .mod2-icons {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .mod2-icons {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 模块三 */

.module-feature {
  background: #F5F5F5;
}

/* 容器 */
.module-feature .mod3-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 背景图（不参与渐入） */
.module-feature .mod3-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 标题区 */
.module-feature .mod3-header {
  position: absolute;
  left: 180px;
  top: 200px;
  z-index: 1;
}

.module-feature .mod3-title {
  font-size: 44px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 14px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 标题下横线 */
.module-feature .mod3-title-line {
  width: 280px;
  height: 1px;
  background: #C9C9C9;
}

/* 时间轴 */
.module-feature .mod3-timeline {
  position: absolute;
  left: 180px;
  right: 120px;
  top: 300px;
  height: 480px;
  display: flex;
  justify-content: space-between;
  z-index: 1;
}

/* 主轴线 */
.module-feature .tl-line {
  position: absolute;
  left: 0;
  right: -150px;
  top: 68%;
  height: 1px;
  background: #C9C9C9;
}

/* 年份条目 */
.module-feature .tl-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 320px;
  height: 100%;
}

/* 下方条目 */
.module-feature .tl-item:nth-child(3) .tl-year {
  margin-bottom: 33px;
}

/* 下方条目 */
.module-feature .tl-item:nth-child(5) .tl-year {
  margin-top: 361px;
}

.module-feature .tl-item:nth-child(even) {
  align-self: flex-start;
}

.module-feature .tl-item:nth-child(odd) {
  align-self: flex-end;
}

/* 年份文字 */
.module-feature .tl-year {
  font-size: 30px;
  font-weight: 500;
  margin: 0 0 12px 15px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  display: inline-flex;
  align-items: center;
  transform: translateY(50px);
}

.module-feature .tl-year-num {
  color: #00ADBB;
  font-size: 30px;
}

.module-feature .tl-year-char {
  color: #252525;
  font-size: 26px;
}

/* 青色指示器 */
.module-feature .tl-year-bar {
  position: absolute;
  left: 0;
  width: 3px;
  height: 43px;
  background: #00ADBB;
  z-index: 2;
}

/* 指示器在竖线顶端 */
.module-feature .tl-year-bar-2025,
.module-feature .tl-year-bar-2021 {
  bottom: -25%;
  margin-right: 40px;
}

/* 指示器在竖线底端 */
.module-feature .tl-year-bar-2026,
.module-feature .tl-year-bar-2024 {
  top: 11%;
  margin-left: 0;
}

/* 年份描述 */
.module-feature .tl-desc {
  font-size: 16px;
  font-weight: 400;
  color: #252525;
  line-height: 1.8;
  margin: 10px 10px 10px 15px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  transform: translateY(35px);
}

/* 各年份字号与间距 */

/* 2026 */
.module-feature .tl-item:nth-child(2) .tl-year { font-size: 30px; margin: 0 0 12px 15px; }
.module-feature .tl-item:nth-child(2) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(2) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 2025 */
.module-feature .tl-item:nth-child(3) .tl-year { font-size: 30px; margin: 405px 0 12px 15px; }
.module-feature .tl-item:nth-child(3) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(3) .tl-year { font-size: 30px; margin: 400px 0 12px 15px; }
:lang(en) .module-feature .tl-item:nth-child(3) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 2024 */
.module-feature .tl-item:nth-child(4) .tl-year { font-size: 30px; margin: 0 0 12px 15px; }
.module-feature .tl-item:nth-child(4) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(4) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 2021 */
.module-feature .tl-item:nth-child(5) .tl-year { font-size: 30px; margin: 430px 0 12px 15px; }
.module-feature .tl-item:nth-child(5) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; }
:lang(en) .module-feature .tl-item:nth-child(5) .tl-year { font-size: 30px; margin: 415px 0 12px 15px; }
:lang(en) .module-feature .tl-item:nth-child(5) .tl-desc { font-size: 16px; margin: 10px 10px 10px 15px; line-height: 1.4; }

/* 竖线 */
.module-feature .tl-stem-2026,
.module-feature .tl-stem-2025,
.module-feature .tl-stem-2024,
.module-feature .tl-stem-2021 {
  position: absolute;
  left: 0;
  width: 1px;
  height: 270px;
  background: #C9C9C9;
  margin-left: 1px;
}

/* 上方竖线 */
.module-feature .tl-stem-2026,
.module-feature .tl-stem-2024 {
  top: 68%;
  transform: translateY(-270px);
}

/* 下方竖线 */
.module-feature .tl-stem-2025,
.module-feature .tl-stem-2021 {
  top: 69%;
  transform: translateY(0);
}

/* 2026 圆点 */
.module-feature .tl-node-2026 {
  position: absolute;
  top: 68%;
  left: 0;
  width: 10px;
  height: 10px;
  margin-left: -3px;
  border-radius: 50%;
  background: #00ADBB;
  border: 2px solid #00ADBB;
  flex-shrink: 0;
  transform: translateY(-50%);
}

/* 2026 圆点外环 */
.module-feature .tl-node-2026::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  margin-left: -8px;
  margin-top: -8px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid #00ADBB;
  pointer-events: none;
}

/* 其他年份圆点 */
.module-feature .tl-node-2025,
.module-feature .tl-node-2024,
.module-feature .tl-node-2021 {
  position: absolute;
  top: 68%;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #B3B3B3;
  border: 2px solid #B3B3B3;
  flex-shrink: 0;
  transform: translateY(-50%);
}

.module-feature .tl-node-2025 { margin-left: -3px; }
.module-feature .tl-node-2024 { margin-left: -2px; }
.module-feature .tl-node-2021 { margin-left: -3px; }

/* 其他年份圆点外环 */
.module-feature .tl-node-2025::after,
.module-feature .tl-node-2024::after,
.module-feature .tl-node-2021::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  margin-left: -8px;
  margin-top: -8px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid #B3B3B3;
  pointer-events: none;
}

/* 发展历程入场：线与圆点常显，仅文字从下到上 30px */
/* 用独立的 translate 属性，与 .tl-year/.tl-desc 自身的 transform 定位叠加互不覆盖 */
.module-feature .tl-year,
.module-feature .tl-desc {
  opacity: 0;
  translate: 0 30px;
}

.module-feature.is-visible .tl-year,
.module-feature.is-visible .tl-desc {
  opacity: 1;
  translate: 0 0;
  transition: opacity 1s ease,
    translate 1s ease;
}

.module-feature.is-visible .tl-item:nth-child(2) .tl-year,
.module-feature.is-visible .tl-item:nth-child(2) .tl-desc { transition-delay: 0.5s; }
.module-feature.is-visible .tl-item:nth-child(3) .tl-year,
.module-feature.is-visible .tl-item:nth-child(3) .tl-desc { transition-delay: 0.7s; }
.module-feature.is-visible .tl-item:nth-child(4) .tl-year,
.module-feature.is-visible .tl-item:nth-child(4) .tl-desc { transition-delay: 0.9s; }
.module-feature.is-visible .tl-item:nth-child(5) .tl-year,
.module-feature.is-visible .tl-item:nth-child(5) .tl-desc { transition-delay: 1.1s; }

/* 模块四 */

.module-contact {
  background: #FFFFFF;
}

.module-contact .mod4-layout {
  position: relative;
  width: 100%;
  height: 100%;
  top: 20%;
}

/* 标题区 */
.module-contact .mod4-header {
  position: absolute;
  left: 50%;
  top: -1%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.module-contact .mod4-title {
  font-size: 44px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 10px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 标题下横线 */
.module-contact .mod4-title-line {
  width: 420px;
  height: 1px;
  background: #C9C9C9;
}

/* 桌面端地图：点击跳转高德定位公司 */
.module-contact .mod4-map {
  position: absolute;
  left: 318px;
  top: 87px;
  width: 1320px;
  height: 700px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.module-contact .mod4-map-img {
  display: block;
  width: 96%;
  height: 96%;
  object-fit: cover;
}

/* 地图定位气泡 */
.module-contact .mod4-map-pin {
  position: absolute;
  left: 283px;
  top: 230px;
  width: 326px;
  height: auto;
  pointer-events: none;
}

/* 英文版地图气泡位置：英文地图 1284x700，定位点比例与中文图不同 */
:lang(en) .module-contact .mod4-map-pin {
  width: 300px;
  height: auto;
  left: 245px;
  top: 120px;
}

/* 白卡容器：桌面端为右侧白色信息卡，内部纵向排列，二维码贴底 */
.module-contact .mod4-panel {
  position: absolute;
  left: 1130px;
  top: 117px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 422px;
  height: 620px;
  padding: 42px 40px;
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

/* 信息内容区：白卡框由 .mod4-panel 承担 */
.module-contact .mod4-left {
  position: static;
}

/* 英文版文字区位置 */
.module-contact .mod4-company {
  font-size: 28px;
  font-weight: 500;
  color: #00ADBB;
  margin: 0 0 24px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 英文版公司名称字号 */
:lang(en) .module-contact .mod4-company {
  font-size: 26px;
}

.module-contact .mod4-company-line {
  width: 40px;
  height: 2px;
  background: #B3B3B3;
  margin-bottom: 24px;
}

.module-contact .mod4-section-title {
  font-size: 24px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 4px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 英文版小节标题间距 */
:lang(en) .module-contact .mod4-section-title {
  margin-bottom: 6px;
}

.module-contact .mod4-info {
  font-size: 20px;
  font-weight: 400;
  color: #00ADBB;
  margin: 0 0 4px 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

.module-contact .mod4-info-label {
  color: #252525;
}

.module-contact .mod4-info-value {
  color: #00ADBB;
}

.module-contact .mod4-section {
  margin-bottom: 32px;
}

/* 英文版小节间距 */
:lang(en) .module-contact .mod4-section {
  margin-bottom: 20px;
}

/* 二维码标签 */
.module-contact .mod4-qr-label {
  font-size: 16px;
  color: #00ADBB;
  text-align: center;
  white-space: pre-line;
  line-height: 1.5;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 桌面端白卡内的二维码布局：仅宽屏生效，手机端保持原有样式 */
@media (min-width: 1025px) {
  .module-contact .mod4-qr-row {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    width: 100%;
    margin-top: auto;
    padding-top: 6px;
  }

  .module-contact .mod4-qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 110px;
  }

  .module-contact .mod4-img1,
  .module-contact .mod4-img2 {
    width: 130px;
    height: auto;
    border: 1px solid #E8E8E8;
    border-radius: 6px;
  }

  .module-contact .mod4-qr-label1,
  .module-contact .mod4-qr-label2 {
    width: 100%;
    margin: 0;
  }
}

/* 公司地址：桌面端由地图气泡展示，隐藏卡片 */
.module-contact .mod4-address {
  position: absolute;
  right: 380px;
  top: 44%;
  width: 520px;
  display: none;
}

.module-contact .mod4-address-desc {
  font-size: 20px;
  color: #252525;
  line-height: 1.7;
  margin: 0;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
}

/* 英文版地址位置 */
:lang(en) .module-contact .mod4-address {
  top: 45.3%;
}

/* 英文版地址文字 */
:lang(en) .module-contact .mod4-address-desc {
  font-size: 18px;
  text-align: justify;
}

/* 卡片结构：手机端启用，桌面端拆平 */
.module-contact .mod4-card,
.module-contact .mod4-card-content {
  display: contents;
}

.module-contact .mod4-card-icon,
.module-contact .mod4-card-arrow,
.module-contact .mod4-qr-heading {
  display: none;
}

/* 二维码标签分行 */
.module-contact .mod4-qr-label span {
  display: block;
}

/* 入场：白色块由下往上，青色地址气泡渐显（仅桌面，手机端白卡为 display:contents） */
@media (min-width: 1025px) {
  .module-contact .mod4-panel {
    opacity: 0;
    transform: translateY(40px);
  }

  .module-contact.is-visible .mod4-panel {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.1s ease 0.2s,
      transform 1.1s ease 0.2s;
  }

  .module-contact .mod4-map-pin {
    opacity: 0;
  }

  .module-contact.is-visible .mod4-map-pin {
    opacity: 1;
    transition: opacity 1.2s ease 0.4s;
  }
}

/* 页脚 */
.about-page >>> .footer {
  scroll-snap-align: end;
}

/* 移动端 */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    transform-origin: top left !important;
    width: 100% !important;
    height: 100% !important;
  }

  /* 禁止 flex 压缩，避免分割线被压成 0 */
  .about-page .section-inner * {
    flex-shrink: 0;
  }

  /* 模块一 */
  .module-hero .mod1-content {
    gap: 3vh;
    padding: 0;
  }

  .module-hero .mod1-title {
    font-size: 7.5vw;
    letter-spacing: 1vw;
  }

  .module-hero .mod1-subtitle {
    font-size: 4.8vw;
    letter-spacing: 0.5vw;
    text-align: center;
  }

  .module-hero .mod1-btn {
    font-size: 4.27vw;
    padding: 1.5vh 7vw;
  }

  /* 模块二 */
  .module-intro .mod2-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  .module-intro .mod2-header {
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0 6%;
  }

  .module-intro .mod2-title {
    font-size: 6.4vw;
    margin: 0 0 1vh 0;
  }

  .module-intro .mod2-subtitle {
    font-size: 4.27vw;
  }

  .module-intro .mod2-divider {
    position: static;
    align-self: flex-start;
    width: 40vw;
    margin: 2vh 0 2vh 6%;
  }

  .module-intro .mod2-desc {
    position: static;
    width: auto;
    box-sizing: border-box;
    padding: 0 6%;
    font-size: 3.8vw;
    line-height: 1.5;
  }

  :lang(en) .module-intro .mod2-desc {
    font-size: 3.4vw;
  }

  .module-intro .mod2-icons {
    position: static;
    margin-top: 2vh;
    gap: 26vw;
  }

  .module-intro .mod2-icon {
    width: 4vh;
  }

  .module-intro .mod2-icon-label {
    font-size: 3.2vw;
    margin-top: -1.5vh;
  }

  :lang(en) .module-intro .mod2-icon-label {
    font-size: 3vw;
  }

  .module-intro .mod2-img {
    position: static;
    width: 100%;
    max-height: 30vh;
    object-fit: contain;
    margin-top: 2vh;
    transform: none;
  }

  /* 入场动效 */
  .reveal-section .mod2-img {
    transform: translateY(48px);
  }

  .reveal-section.is-visible .mod2-img {
    transform: translateY(0);
  }

  /* 模块三 */
  .module-feature .mod3-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  .module-feature .mod3-header {
    position: static;
    align-self: stretch;
    padding: 0 6%;
  }

  .module-feature .mod3-title {
    font-size: 5.87vw;
    margin: 0 0 2vh 0;
  }

  .module-feature .mod3-title-line {
    width: 30vw;
  }

  .module-feature .mod3-timeline {
    position: static;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 3vh;
    width: 100%;
    box-sizing: border-box;
    padding: 3vh 6% 2vh 9vw;
  }

  /* 主轴线由各条目伪元素拼接，长度随首尾圆点 */
  .module-feature .tl-line {
    display: none;
  }

  /* 竖线段：跨过条目间距接下项圆点 */
  .module-feature .tl-item::before {
    content: '';
    position: absolute;
    left: -6vw;
    top: 2.2vh;
    bottom: calc(-3vh - 2.2vh);
    width: 1px;
    background: #C9C9C9;
  }

  /* 末项不画线 */
  .module-feature .tl-item:last-child::before {
    display: none;
  }

  .module-feature .tl-item {
    position: relative;
    width: auto;
    height: auto;
    padding-left: 5vw;
  }

  /* 重置桌面交错对齐 */
  .module-feature .tl-item:nth-child(even),
  .module-feature .tl-item:nth-child(odd) {
    align-self: stretch;
  }

  /* 清除桌面 transform 偏移 */
  .module-feature .tl-item:nth-child(2) .tl-year,
  .module-feature .tl-item:nth-child(3) .tl-year,
  .module-feature .tl-item:nth-child(4) .tl-year,
  .module-feature .tl-item:nth-child(5) .tl-year {
    transform: none !important;
    margin: 0 0 1vh 0 !important;
  }

  .module-feature .tl-year-num {
    font-size: 6vw !important;
  }

  :lang(en) .module-feature .tl-year-num {
    font-size: 5.5vw !important;
  }

  .module-feature .tl-year-char {
    font-size: 4.6vw !important;
  }

  :lang(en) .module-feature .tl-item:nth-child(2) .tl-year,
  :lang(en) .module-feature .tl-item:nth-child(3) .tl-year,
  :lang(en) .module-feature .tl-item:nth-child(4) .tl-year,
  :lang(en) .module-feature .tl-item:nth-child(5) .tl-year {
    margin: 0 0 1vh 0 !important;
  }

  .module-feature .tl-item:nth-child(2) .tl-desc,
  .module-feature .tl-item:nth-child(3) .tl-desc,
  .module-feature .tl-item:nth-child(4) .tl-desc,
  .module-feature .tl-item:nth-child(5) .tl-desc {
    transform: none !important;
    font-size: 3.8vw !important;
    text-align: justify;
    line-height: 1.5;
    margin: 0 0 2vh 0 !important;
  }

  :lang(en) .module-feature .tl-item:nth-child(2) .tl-desc,
  :lang(en) .module-feature .tl-item:nth-child(3) .tl-desc,
  :lang(en) .module-feature .tl-item:nth-child(4) .tl-desc,
  :lang(en) .module-feature .tl-item:nth-child(5) .tl-desc {
    font-size: 3vw !important;
    text-align: justify;
    line-height: 1.4;
    margin: 0 0 2vh 0 !important;
  }

  /* 隐藏青色指示器 */
  .module-feature .tl-year-bar,
  .module-feature .tl-year-bar-2025,
  .module-feature .tl-year-bar-2021,
  .module-feature .tl-year-bar-2026,
  .module-feature .tl-year-bar-2024 {
    display: none;
  }

  /* 隐藏横向连接线 */
  .module-feature .tl-stem-2026,
  .module-feature .tl-stem-2025,
  .module-feature .tl-stem-2024,
  .module-feature .tl-stem-2021 {
    display: none;
  }

  /* 圆点 */
  .module-feature .tl-node-2026,
  .module-feature .tl-node-2025,
  .module-feature .tl-node-2024,
  .module-feature .tl-node-2021 {
    position: absolute;
    top: 2.2vh;
    left: -6vw;
    margin-left: -5px;
    transform: translateY(-50%);
  }

  /* 模块四 */
  .module-contact .mod4-layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 76px 0 3vh;
    top: auto;
  }

  .module-contact .mod4-header {
    position: static;
    transform: none;
  }

  .module-contact .mod4-title {
    font-size: 5.87vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .module-contact .mod4-title {
    font-size: 5.87vw;
  }

  .module-contact .mod4-title-line {
    width: 56vw;
  }

  /* 白卡容器：手机端拆平，内部信息卡回到原列表布局 */
  .module-contact .mod4-panel {
    display: contents;
  }

  /* 左侧文字区 */
  .module-contact .mod4-left {
    position: static;
    width: 88%;
    margin-top: 2vh;
  }

  /* 桌面端地图在手机端隐藏 */
  .module-contact .mod4-map {
    display: none;
  }

  .module-contact .mod4-company {
    font-size: 5.6vw;
    margin: 0 0 1vh 0;
  }

  :lang(en) .module-contact .mod4-company {
    font-size: 4.6vw;
  }

  .module-contact .mod4-company-line {
    margin-bottom: 2vh;
  }

  .module-contact .mod4-section {
    margin-bottom: 0;
  }

  :lang(en) .module-contact .mod4-section {
    margin-bottom: 0;
  }

  /* 售后/商务卡片*/
  .module-contact .mod4-card {
    display: flex;
    align-items: flex-start;
    gap: 3vw;
    box-sizing: border-box;
    width: 100%;
    padding: 1vh 4vw;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    border-radius: 12px;
  }

  .module-contact .mod4-card + .mod4-card {
    margin-top: 2vh;
  }

  .module-contact .mod4-card-content {
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    flex-shrink: 1 !important;  /* 允许收窄换行 */
  }

  .module-contact .mod4-card-icon {
    display: block;
    width: 8vw;
    height: auto;
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: 3vh;
  }

  .module-contact .mod4-section-title {
    font-size: 4.4vw;
    margin: 0;
  }

  :lang(en) .module-contact .mod4-section-title {
    margin-bottom: 0;
  }

  .module-contact .mod4-info {
    font-size: 3.6vw;
    margin: 0 0 0vh 0;
    word-break: break-all;   /* 长邮箱地址允许断行防溢出 */
  }

  :lang(en) .module-contact .mod4-info {
    font-size: 3.6vw;
  }

  /* 地址卡片 */
  .module-contact .mod4-address {
    position: static;
    order: 1;
    display: flex;
    align-items: center;
    gap: 3vw;
    box-sizing: border-box;
    width: 88%;
    margin-top: 2vh;
    padding: 1vh 4vw;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    border-radius: 12px;
    top: auto;
  }

  .module-contact .mod4-address .mod4-card-content {
    flex: 1 1 auto;
    min-width: 0;
  }

  .module-contact .mod4-address-desc {
    font-size: 3.4vw;
    color: #868686;
    line-height: 1.5;
  }

  :lang(en) .module-contact .mod4-address-desc {
    font-size: 3vw;
  }

  /* 地址卡片箭头 */
  .module-contact .mod4-card-arrow {
    position: relative;
    display: block;
    width: 2.2vw;
    height: 2.2vw;
    border-top: 1.5px solid #B3B3B3;
    border-right: 1.5px solid #B3B3B3;
    transform: rotate(45deg);
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: 1.4vh;
    margin-right: 0.5vw;
    cursor: pointer;
  }

  /* 箭头点击热区 */
  .module-contact .mod4-card-arrow::before {
    content: '';
    position: absolute;
    top: -14px;
    right: -14px;
    bottom: -14px;
    left: -14px;
  }

  .module-contact .mod4-qr-heading {
    order: 2;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1vh;
    box-sizing: border-box;
    width: 88%;
    margin-top: 2.2vh;
  }

  .module-contact .mod4-qr-title {
    font-size: 4.4vw;
    font-weight: 500;
    color: #00ADBB;
    margin: 0;
    font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  }

  .module-contact .mod4-qr-underline {
    width: 7vw;
    height: 2px;
    background: #00ADBB;
  }

  .module-contact .mod4-qr-row {
    position: static;
    order: 3;
    display: flex;
    justify-content: space-between;
    gap: 2.5vw;
    width: 88%;
    height: auto;
    margin-top: 2vh;
    padding: 2.2vh 2vw;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    border-radius: 12px;
    pointer-events: auto;
  }

  .module-contact .mod4-qr-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2vw;
    flex: 1;
    box-sizing: border-box;
  }

  .module-contact .mod4-img1,
  .module-contact .mod4-img2 {
    position: static;
    transform: none;
    width: 18vw;
    flex-shrink: 0;
    border: 2px solid #00ADBB;
    border-radius: 6px;
  }

  .module-contact .mod4-qr-label1,
  .module-contact .mod4-qr-label2 {
    position: static;
    width: auto;
    margin: 0;
    font-size: 2.9vw;
    line-height: 1.5;
    text-align: left;
    flex: 1 1 auto;
    min-width: 0;
    flex-shrink: 1 !important;
    word-break: break-word;
  }

  /* 二维码文案 */
  .module-contact .mod4-qr-scan,
  .module-contact .mod4-qr-name {
    color: #00ADBB;
  }

  /* 地图选择弹层 */
  /* host 不参与布局，弹层 fixed 到视口 */
  .map-picker-host {
    display: contents;
  }

  .map-picker-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4000;
    display: flex;
    align-items: flex-end;
    background: rgba(0, 0, 0, 0.45);
  }

  .map-picker {
    width: 100%;
    box-sizing: border-box;
    padding: 2.4vh 6vw calc(2vh + env(safe-area-inset-bottom, 0px));
    background: #FFFFFF;
    border-radius: 16px 16px 0 0;
    font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
    animation: mapPickerUp 0.25s ease;
  }

  @keyframes mapPickerUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }

  .map-picker-title {
    padding-bottom: 1.2vh;
    font-size: 3.6vw;
    color: #868686;
    text-align: center;
  }

  .map-picker-item {
    padding: 1.9vh 0;
    font-size: 4.3vw;
    color: #252525;
    text-align: center;
    border-top: 1px solid #F0F0F0;
    cursor: pointer;
  }

  .map-picker-item:active {
    background: #F7F7F7;
  }

  .map-picker-cancel {
    margin-top: 1.6vh;
    padding: 1.6vh 0;
    font-size: 4.3vw;
    color: #868686;
    text-align: center;
    background: #F5F5F5;
    border-radius: 12px;
    cursor: pointer;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
